import { TranslationCatalog } from './translations.types';

/** Textos transversales de la app autenticada (se cargan con la app; deben ser pocos). */
export const COMMON_TRANSLATIONS: TranslationCatalog = {
  es: {
    'common.unsaved.title': '¿Salir sin guardar?',
    'common.unsaved.message': 'Tienes cambios sin guardar. Si sales ahora, se perderán.',
    'common.unsaved.confirm': 'Salir sin guardar',
    'common.unsaved.cancel': 'Seguir editando',
    'common.cancel': 'Cancelar',
    'common.retry': 'Reintentar',
    'common.pagination.previous': 'Anterior',
    'common.pagination.next': 'Siguiente',
    'common.pagination.page': 'Página',
    'common.pagination.label': 'Paginación',
    'common.pagination.summary': 'Mostrando {from}–{to} de {total}',

    // Navegación (menú lateral y barra móvil; ver features/dashboard/navigation)
    'nav.account': 'Mi cuenta',
    'nav.dashboard': 'Dashboard',
    'nav.vacancies': 'Vacantes',
    'nav.candidates': 'Candidatos',
    'nav.postulations': 'Postulaciones',
    'nav.evaluations': 'Evaluaciones',
    'nav.publications': 'Publicaciones',
    'nav.kyc': 'KYC',
    'nav.group.tracking': 'Seguimiento',
    'nav.tracking-analytics': 'Analítica / Reportes',
    'nav.tracking-audit': 'Auditoría',
    'nav.group.administration': 'Administración',
    'nav.admin-companies': 'Clientes / Empresas',
    'nav.permission-roles': 'Usuarios y roles',
    'nav.admin-integrations': 'Integraciones',
    'nav.candidate-dashboard': 'Dashboard',
    'nav.candidate-jobs': 'Buscar empleos',
    'nav.candidate-profile': 'Hoja de vida',
    'nav.candidate-postulations': 'Mis postulaciones',
    'nav.candidate-evaluations': 'Mis evaluaciones',
    'nav.candidate-kyc': 'Verificación KYC',
    'nav.bottom.candidate-profile': 'Hoja de vida',
    'nav.bottom.candidate-postulations': 'Postulaciones',
    'nav.bottom.candidate-kyc': 'KYC',
  },
  en: {
    'common.unsaved.title': 'Leave without saving?',
    'common.unsaved.message': 'You have unsaved changes. If you leave now, they will be lost.',
    'common.unsaved.confirm': 'Leave without saving',
    'common.unsaved.cancel': 'Keep editing',
    'common.cancel': 'Cancel',
    'common.retry': 'Retry',
    'common.pagination.previous': 'Previous',
    'common.pagination.next': 'Next',
    'common.pagination.page': 'Page',
    'common.pagination.label': 'Pagination',
    'common.pagination.summary': 'Showing {from}–{to} of {total}',

    // Navigation (side menu and mobile bar; see features/dashboard/navigation)
    'nav.account': 'My account',
    'nav.dashboard': 'Dashboard',
    'nav.vacancies': 'Vacancies',
    'nav.candidates': 'Candidates',
    'nav.postulations': 'Applications',
    'nav.evaluations': 'Assessments',
    'nav.publications': 'Publications',
    'nav.kyc': 'KYC',
    'nav.group.tracking': 'Tracking',
    'nav.tracking-analytics': 'Analytics / Reports',
    'nav.tracking-audit': 'Audit trail',
    'nav.group.administration': 'Administration',
    'nav.admin-companies': 'Clients / Companies',
    'nav.permission-roles': 'Users and roles',
    'nav.admin-integrations': 'Integrations',
    'nav.candidate-dashboard': 'Dashboard',
    'nav.candidate-jobs': 'Search jobs',
    'nav.candidate-profile': 'Resume',
    'nav.candidate-postulations': 'My applications',
    'nav.candidate-evaluations': 'My assessments',
    'nav.candidate-kyc': 'KYC verification',
    'nav.bottom.candidate-profile': 'Resume',
    'nav.bottom.candidate-postulations': 'Applications',
    'nav.bottom.candidate-kyc': 'KYC',
  },
};
